module.exports = __webpack_public_path__ + "assets/images/rbyearend-04-desktop.jpg?v=6e6b48f2";